// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__("./node_modules/@babel/polyfill/lib/index.js")))
let __webpack_exports__ = __webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__("./src/browser/index.jsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
